var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSistemaDeAguaDaChuva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sistema_de_agua_da_chuva",
    "data-name": "sistema de agua da chuva",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 110.573 111.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_106",
    "data-name": "Grupo 106",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_105",
    "data-name": "Grupo 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1232",
    "data-name": "Caminho 1232",
    d: "M89.31,28.207C88.166,12.467,74.538,0,57.95,0A31.31,31.31,0,0,0,28.57,19.53q-.484-.017-.973-.017a27.1,27.1,0,1,0,0,54.2q.424,0,.846-.013a2.21,2.21,0,0,0,.238.013H89.388a2.1,2.1,0,0,0,.46-.05,22.766,22.766,0,0,0-.538-45.457Zm-.041,41.146a2.061,2.061,0,0,0-.23.026H29a1.759,1.759,0,0,0-.407-.021c-.331.013-.666.021-1,.021a22.765,22.765,0,0,1,0-45.53c.757,0,1.507.037,2.244.109a2.163,2.163,0,0,0,2.271-1.477A26.91,26.91,0,0,1,57.95,4.336c14.944,0,27.1,11.672,27.1,26.045a2.166,2.166,0,0,0,.674,1.571,2.079,2.079,0,0,0,1.6.594c.323-.016.647-.024.975-.024a18.428,18.428,0,0,1,.965,36.831Z",
    transform: "translate(-0.496)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1233",
    "data-name": "Caminho 1233",
    d: "M69.06,129.661a2.165,2.165,0,0,0-2.962.794l-5,8.666a2.168,2.168,0,0,0,3.756,2.168l5-8.666A2.168,2.168,0,0,0,69.06,129.661Z",
    transform: "translate(-24.136 -50.71)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1234",
    "data-name": "Caminho 1234",
    d: "M69.06,161.754a2.168,2.168,0,0,0-2.962.794l-5,8.666a2.168,2.168,0,0,0,3.756,2.168l5-8.666A2.168,2.168,0,0,0,69.06,161.754Z",
    transform: "translate(-24.136 -63.29)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1235",
    "data-name": "Caminho 1235",
    d: "M90.455,129.661a2.166,2.166,0,0,0-2.962.794l-5,8.666a2.168,2.168,0,0,0,3.756,2.168l5-8.666A2.168,2.168,0,0,0,90.455,129.661Z",
    transform: "translate(-32.522 -50.71)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1236",
    "data-name": "Caminho 1236",
    d: "M90.455,161.754a2.169,2.169,0,0,0-2.962.794l-5,8.666a2.168,2.168,0,0,0,3.756,2.168l5-8.666A2.168,2.168,0,0,0,90.455,161.754Z",
    transform: "translate(-32.522 -63.29)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1237",
    "data-name": "Caminho 1237",
    d: "M111.85,129.661a2.166,2.166,0,0,0-2.962.794l-5,8.666a2.168,2.168,0,0,0,3.756,2.168l5-8.666A2.168,2.168,0,0,0,111.85,129.661Z",
    transform: "translate(-40.908 -50.71)",
    fill: "#cb8f55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1238",
    "data-name": "Caminho 1238",
    d: "M111.85,161.754a2.169,2.169,0,0,0-2.962.794l-5,8.666a2.168,2.168,0,0,0,3.756,2.168l5-8.666A2.168,2.168,0,0,0,111.85,161.754Z",
    transform: "translate(-40.908 -63.29)",
    fill: "#cb8f55"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSistemaDeAguaDaChuva);
export default __webpack_public_path__ + "static/media/sistema-de-agua-da-chuva.69f830606a3cfa8c98ba9bf2cf54e0a2.svg";
export { ForwardRef as ReactComponent };